<template>
  <div>
    <div id="riskSummary">
      <div>Public Crosswalks in <strong>Hingham, MA</strong> ({{ totalCrosswalks }})</div>
      <div>
        <span class="filterOption">
          <input type="checkbox" id="highRisk" value="1" v-model="checkedRisk"
          v-on:change="updateMarkerVisibility">
          High Risk ({{ riskCategoryCount[1] }}) |
        </span>
        <span class="filterOption">
          <input type="checkbox" id="medRisk" value="2" v-model="checkedRisk"
          v-on:change="updateMarkerVisibility">
          Moderate Risk ({{ riskCategoryCount[2] }}) |
        </span>
        <span class="filterOption">
          <input type="checkbox" id="lowRisk" value="3" v-model="checkedRisk"
          v-on:change="updateMarkerVisibility">
          Low Risk ({{ riskCategoryCount[3] }})
        </span>
      </div>
    </div>
    <div class='mainMapContainer'>
      <GoogleMapLoader
        :mapConfig='mapConfig'
        :apiKey='apiKey'
      >
        <template slot-scope="{ google, map }">
          <GoogleMapMarker
            v-for="crossing in crosswalks"
            :key="crossing._id"
            :marker="marker(crossing)"
            :google="google"
            :map="map"
            :defaultShow="getIntendedVisibility(crossing)"
          />
        </template>
      </GoogleMapLoader>
      <CrosswalkModal v-if="showModal" @modal-close="showModal = false"
        :permCrosswalk='currentCrosswalk'
        :riskCount='currentCrosswalkRiskCount'
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapSettings } from '@/consts/mapSettings';
import EventBus from '@/event-bus';
import CrosswalkModal from '@/components/CrosswalkModal.vue';
import GoogleMapLoader from './GoogleMapLoader.vue';
import GoogleMapMarker from './GoogleMapMarker.vue';

const resultsHash = {};

export default {
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    CrosswalkModal,
  },

  data() {
    return {
      loading: false,
      crosswalks: null,
      apiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
      showModal: false,
      currentCrosswalk: null,
      currentCrosswalkRiskCount: null,
      totalCrosswalks: 0,
      riskCategoryCount: [0, 0, 0, 0],
      checkedRisk: ['1', '2'],
    };
  },

  created() {
    EventBus.$on('modal-open', (payload) => {
      this.payload = payload;
      this.showModal = true;
      this.currentCrosswalk = resultsHash[payload];
      this.currentCrosswalkRiskCount = this.riskCategoryCount[this.currentCrosswalk.riskLevel];
    });

    EventBus.$on('crosswalk-save', (updatedCrosswalk) => {
      // update the local collection
      resultsHash[updatedCrosswalk._id] = updatedCrosswalk;
      // re-calculate risk level counts
      this.riskCategoryCount = [0, 0, 0, 0];
      Object.values(this.crosswalks).forEach((v) => {
        this.riskCategoryCount[v.riskLevel] += 1;
      });
      this.updateMarkerVisibility();
    });
  },

  destroyed() {
    EventBus.$off('modal-open');
    this.$markers.length = 0;
  },

  async mounted() {
    const client = axios.create({
      baseURL: 'https://7yt2za0ijd.execute-api.us-east-1.amazonaws.com/dev/',
      // baseURL: 'http://localhost:8081',
    });
    const { data } = await client.get('/crosswalks');
    this.crosswalks = data.crosswalks;
    Object.values(this.crosswalks).forEach((v) => {
      // eslint-disable-next-line
      this.$markerIndex[v._id] = [];
      this.riskCategoryCount[v.riskLevel] += 1;
      this.totalCrosswalks += 1;
    });
    this.$set(this.riskCategoryCount, 1, this.riskCategoryCount[1]);
  },

  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter,
      };
    },
    mapCenter() {
      // center on Hingham, MA
      return { lat: 42.224040, lng: -70.886555 };
    },
  },

  methods: {
    marker(crossing) {
      const pos = { lat: crossing.lat, lng: crossing.lng };
      const ttl = crossing.displayName;
      const pri = crossing.riskLevel;
      const objId = crossing._id;
      resultsHash[objId] = crossing;
      return {
        position: pos,
        title: ttl,
        priority: pri,
        id: objId,
      };
    },

    getIntendedVisibility(crossing) {
      return this.checkedRisk.includes(crossing.riskLevel.toString());
    },

    updateMarkerVisibility() {
      Object.values(this.$markers).forEach((m) => {
        if (this.checkedRisk.includes(m.marker.priority.toString())) {
          m.setVisible(true);
        } else m.setVisible(false);
      });
    },
  },
};
</script>
<style>

@media only screen and (max-height: 875px) {
  .mainMapContainer {
    height: 540px !important;
  }
}

.mainMapContainer {
  height:700px;
  width: 100%;
}

.filterOption{
  display: inline-block;
}

#riskSummary {
  padding-bottom: 14px;
}
</style>
